import { IAnyObject } from '../../services/error/error.handler';
import { TypeaheadOptions, TypeaheadValue } from '../typeahead/typeahead.model';

export interface CustomApiQuery {
  searchValueProperty: string;
  requestBody: IAnyObject;
}

export enum TypeaheadRequestType {
  GET,
  POST
}

export interface ExtendedTypeaheadOptions extends TypeaheadOptions {
  minSearchAmount?: number;
  pluckValueFromResult?: string;
  requestType?: TypeaheadRequestType
}
